import axiosInstance from './axiosInstance';

export default async function fetchStreamList(host) {
  try {
    const { data } = await axiosInstance.get(`${window.location.protocol}//${host}/api/v1/sensor/streams`);
		console.log("stream list: ", data);
    return data;
  } catch (error) {
    console.log('Failed to fetch stream list', error.response);
  }
  return null;
};
